import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { ColorDTO } from '@/api/dto/ColorDTO';

export class ColorCRUD extends CrudEndpoint<ColorDTO> {
  constructor() {
    super('color');
  }
}
